import { render, staticRenderFns } from "./logActivityStatistics.vue?vue&type=template&id=59f97ad0&scoped=true"
import script from "./logActivityStatistics.vue?vue&type=script&lang=js"
export * from "./logActivityStatistics.vue?vue&type=script&lang=js"
import style0 from "./logActivityStatistics.vue?vue&type=style&index=0&id=59f97ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f97ad0",
  null
  
)

export default component.exports